export default "__VITE_ASSET__b89efae6__"